import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
// import { PermissionButton, WhiteButton } from './styles';
// import cam from '../../../assets/cam.svg';
// import { StandartPage } from '../../design/StandartPage';
// import { Container } from '../../design/Container';
// import { sendMessageToParent } from '../../utils';
import RootContext from '../../context';
import { PATH_INTRO, PATH_ROOT } from '../../paths';

export const NoPermission = () => {
  const { videoParams } = useContext(RootContext);
  if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  // const buttons = <Container>
  //   <WhiteButton onClick={() => sendMessageToParent({ _: 'cancel' })}>
  //     Cancel
  //   </WhiteButton>
  //   <PermissionButton onClick={() => sendMessageToParent({ _: 'restart' })}>
  //     Grant access to camera
  //   </PermissionButton>
  // </Container>;
  return (
    <>
      no permission
    </>
  );
};
/*
      <StandartPage
        image={cam}
        title={'We can’t go on your permission'}
        underText={'Our App needs an access to your camera only to use it for your security and privacy. The face scan will not be given to third parties'}
        buttons={buttons}
      />
 */
